import { Avatar as MaterialAvatar } from '@material-ui/core';
import * as React from 'react';

import { config } from '../config';

interface Entity {
    profilePicUrl?: string;
    name: {
        first: string;
        full: string;
        last: string;
    };
}

interface AvatarProps<T extends Entity> {
    entity: T;
    size?: number;
}

const defaultSize = 40;

export const Avatar = <T extends Entity>(props: AvatarProps<T>) => {
    const entity = props.entity;
    const size = props.size || defaultSize;
    let avatarText: string;
    let avatarUrl: string;
    if (entity.profilePicUrl && entity.profilePicUrl.match(/^images/)) {
        avatarUrl = `${config.AssetHost}/${entity.profilePicUrl}`;
    }
    if (!avatarUrl) {
        avatarText = entity.name.first.charAt(0).toLocaleUpperCase() + entity.name.last.charAt(0).toLocaleUpperCase();
    }
    const avatarStyle = { width: size, height: size, flex: '0 0 auto', fontSize: size / 2 };

    return avatarUrl ? (
        <MaterialAvatar className={'avatar'} src={avatarUrl} style={avatarStyle} />
    ) : (
        <MaterialAvatar className={'avatar'} style={avatarStyle}>
            {avatarText}
        </MaterialAvatar>
    );
};
